module.exports = __webpack_public_path__ + "img/cast_ic_loading.41843d88.gif";